export interface FrameTimeSummary {
  samples: number
  averageFps: number
  p50Ms: number
  p95Ms: number
  p99Ms: number
  worstMs: number
}

export function summarizeFrameTimes(frameTimesSeconds: readonly number[]): FrameTimeSummary {
  const values = frameTimesSeconds
    .filter((value) => Number.isFinite(value) && value > 0)
    .sort((left, right) => left - right)

  if (values.length === 0) {
    return { samples: 0, averageFps: 0, p50Ms: 0, p95Ms: 0, p99Ms: 0, worstMs: 0 }
  }

  const totalSeconds = values.reduce((total, value) => total + value, 0)
  const milliseconds = (value: number): number => Number((value * 1000).toFixed(2))
  const percentile = (ratio: number): number => {
    const index = Math.min(values.length - 1, Math.max(0, Math.ceil(values.length * ratio) - 1))
    return milliseconds(values[index] ?? 0)
  }

  return {
    samples: values.length,
    averageFps: Math.round(values.length / totalSeconds),
    p50Ms: percentile(0.5),
    p95Ms: percentile(0.95),
    p99Ms: percentile(0.99),
    worstMs: milliseconds(values[values.length - 1] ?? 0),
  }
}
